import React from "react";
const SpoilerContext = React.createContext(null);
const SpoilerContextProvider = ({ spoilerManager, children }) => {
  return /* @__PURE__ */ React.createElement(SpoilerContext.Provider, { value: { spoilerManager } }, children);
};
export {
  SpoilerContext,
  SpoilerContextProvider
};
//# sourceMappingURL=spoiler-context.js.map
